import { hasKey } from '@dicetechnology/doris-core';
import type { MediaInformation } from 'chromecast-caf-receiver/cast.framework.messages';

export const getAudioTracksWithForcedTextTracks = (media: MediaInformation): number[] => {
    // Check if there is a subtitle policy in effect
    const mediaCustomData: unknown = media?.customData;
    if (
        !mediaCustomData ||
        !hasKey(mediaCustomData, 'audioTracksWithForcedTextTracks') ||
        !Array.isArray(mediaCustomData.audioTracksWithForcedTextTracks) ||
        !mediaCustomData.audioTracksWithForcedTextTracks.every((entry) => typeof entry === 'number')
    ) {
        return [];
    }
    return mediaCustomData.audioTracksWithForcedTextTracks;
};
